module.exports = __webpack_public_path__ + "static/media/nielsen_logo_root.736072f6.jpg";